import { types } from 'mobx-state-tree';

export const ApplicationTypesModel = types.model('ApplicationTypesModel', {
  diggingPermit: types.boolean,
  leasehold: types.boolean,
  trafficArrangementPlan: types.boolean
});
